module.exports = __webpack_public_path__ + "img/img_side_ribbons.90ec16d8.png";